import { ShoppingBag } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

import { SALES_CHANNEL_COPY } from '#app/routes/mocra+/_form+/components/sales-channels/constants.ts'
import {
	formatSalesChannelSummary,
	salesChannelCardTitle,
	type SalesChannelDraft,
} from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'

type Props = {
	readonly channel: SalesChannelDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function SalesChannelCard({
	channel,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = salesChannelCardTitle(channel)
	const summary = formatSalesChannelSummary(channel)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={SALES_CHANNEL_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				SALES_CHANNEL_COPY.actions.removeConfirmDescription
			}
			icon={
				<ShoppingBag
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove sales channel"
		/>
	)
}
